export const getters = {
    loginAttempts: state => state.attempts,
    usernames: state => state.username,
    profileImg: state => state.profilePic,
    roleuserModules: state => state.usermodules,
    permissionuserModules: state => state.permissionModules
}

export default getters



// WEBPACK FOOTER //
// ./src/vuex/modules/auth/getters.js